module.exports = __webpack_public_path__ + "img/disaster-recovery-solutionsimg-1.2b7e63b3.png";